import script from "./ChatTicketAction.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatTicketAction.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__